"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findingDescriptorSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
exports.findingDescriptorSchema = zod_1.z.object({
    id: zod_1.z.string(),
    findingNumber: zod_1.z.number(),
    severity: enums_1.RequirementSeveritySchema,
    message: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
});
//# sourceMappingURL=finding-descriptor.js.map